import { render, staticRenderFns } from "./DetailStore.vue?vue&type=template&id=49b41903&"
import script from "./DetailStore.vue?vue&type=script&lang=js&"
export * from "./DetailStore.vue?vue&type=script&lang=js&"
import style0 from "./DetailStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports